import React, { useState, useCallback, useMemo, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"
import { useSelector } from "react-redux"
import StickyHeadTable from "@/components/common/StickyHeadTable"
import { getUserTopRole } from "@/utils"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
    actionButtonContainer: {
        display: "flex",
        gap: "12px",
        justifyContent: "flex-end",
    },
}))

const ViewDepartmentTable = memo((props) => {
    const { departmentData, handleEditClickOpen, handleSetViewDepartmentEditDetail, handleDeleteClickOpen } = props
    const classes = useStyles()
    const [columns] = useState(() => [{ id: "department", label: "Department Name", minWidth: 50 }])

    const departmentEditItem = useCallback((e, rowData) => {
        e.stopPropagation()
        const { departmentId, companyId, department } = rowData
        handleSetViewDepartmentEditDetail({
            display: true,
            departmentId,
            companyId,
            department,
        })
        handleEditClickOpen()
    }, [])

    const userRoleData = useSelector((state) => state.userRoleReducer)
    const userData = useSelector((state) => state.userReducer)
    const { user } = userData
    const { userRolesArray } = userRoleData
    const loginUserRoles = userRolesArray.find((userRoleItem) => userRoleItem.userId === user.userId).userRoles
    const topRole = useMemo(() => getUserTopRole(loginUserRoles), userRolesArray)
    const accountHolderRole = topRole.roleName === process.env.ACCOUNT_HOLDER

    return (
        <Box mt={1} className={classes.participantNoRoleListTableWrapper}>
            <StickyHeadTable
                columns={columns}
                rows={[...departmentData.data.generalDepartment, ...departmentData.data.companyUniqueDepartment]}
                tableTitle="Current Department"
                extraColumns={[
                    {
                        column: { id: "Edit", label: "", minWidth: 350, align: "left" },
                        action: ({ rowData }) =>
                            rowData.companyId && (
                                <Box className={classes.actionButtonContainer}>
                                    <Button variant="outlined" color="primary" onClick={(e) => departmentEditItem(e, rowData)}>
                                        Edit
                                    </Button>
                                    {accountHolderRole && (
                                        <Button variant="contained" color="primary" onClick={() => handleDeleteClickOpen(true, rowData)}>
                                            Delete
                                        </Button>
                                    )}
                                </Box>
                            ),
                    },
                ]}
            />
        </Box>
    )
})

export default ViewDepartmentTable
